import * as React from "react";
import styled from "styled-components";
import { Tab } from "./Tab";
import { Surface, SurfaceProps } from "../../atoms/Surface";

type TabProps = {
    label: string | React.ReactNode
    tooltip?: string | React.ReactNode
    active?: boolean
    disabled?: boolean
    onClick?: ()=>void
}

type TabbedSurfaceProps = SurfaceProps & {
    tabs: Array<TabProps>
    inactiveColor?: "secondary"|"contrast"
    onClick?: (tabIndex:number) => void

    style?: React.CSSProperties
    className?: string
}

const TabbedSurfaceContainer = styled.div<{first: boolean}>`
    display: flex;
    flex-direction: column;
    
    >:nth-child(1) {
        position: relative;
        z-index: 1;
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-start;
    }

    >:nth-child(2) {
        ${props => props.first && `border-top-left-radius: 0;`}
        overflow: hidden;
        &>div {
            overflow: auto;
            position: relative;
            z-index: 1;
        }
    }
`;

const TabbedSurface: React.FC<TabbedSurfaceProps> = (props) => {
    const { tabs, onClick, style, className, inactiveColor, children, ...surfaceProps } = props;

    const handleClick = (tabIdx: number) => {
        onClick && onClick(tabIdx);
        let tab = tabs[tabIdx]!;
        tab.onClick && tab.onClick();
    };

    const first = !!tabs[0]!.active;

    return <TabbedSurfaceContainer first={first} className={className} style={style}>
        <ul>
            {tabs.map((tab, idx) =>
                <Tab
                    key={idx} // Don't have anything else we can use...
                    onClick={() => handleClick(idx)}
                    elevation={surfaceProps.elevation}
                    radius={surfaceProps.radius}
                    disabled={tab.disabled}
                    inactiveColor={inactiveColor}
                    active={tab.active}>
                    {tab.label}
                </Tab>
            )}
        </ul>
        <Surface {...surfaceProps}>
            <div>{children}</div>
        </Surface>
    </TabbedSurfaceContainer> 
}

export default TabbedSurface;
export { TabbedSurface, TabbedSurfaceProps };